/**
 * AppRoutes
 *
 * Assembles the full `<Routes>` tree for the authenticated admin portal from
 * cohesive per-domain route groups under `./groups/`. Each group owns its own
 * lazy page imports and redirect helpers.
 *
 * NOTE: Ordering of the group fragments — and of the `<Route>` elements inside
 * each group — is preserved verbatim from the original single-file tree. That
 * sequence, and the total route count, are locked by
 * `__tests__/AppRoutes.structure.test.tsx`.
 */

import { Routes } from 'react-router-dom';
import { coreRoutes } from './groups/coreRoutes';
import { lendingRoutes } from './groups/lendingRoutes';
import { operationsRoutes } from './groups/operationsRoutes';
import { administrationRoutes } from './groups/administrationRoutes';
import { platformRoutes } from './groups/platformRoutes';

// ---------------------------------------------------------------------------
// Helpers
// ---------------------------------------------------------------------------

const PageLoader = () => (
    <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '200px',
        color: 'var(--color-text-secondary)'
    }}>
        <div>Loading...</div>
    </div>
);

// ---------------------------------------------------------------------------
// <AppRoutes />
// ---------------------------------------------------------------------------

function AppRoutes() {
    return (
        <Routes>
            {coreRoutes()}
            {lendingRoutes()}
            {operationsRoutes()}
            {administrationRoutes()}
            {platformRoutes()}
        </Routes>
    );
}

export { PageLoader };
export default AppRoutes;
